<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="link"/>
          {{ $t('clientBot') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex">
          <b-tab>
            <template #title>
              {{ $t('all') }}
              <small v-if="!countLoading">({{ count[0] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('teams') }}
              <small v-if="!countLoading">({{ count[1] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('larksuite') }}
              <small v-if="!countLoading">({{ count[2] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('slack') }}
              <small v-if="!countLoading">({{ count[3] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('telegram') }}
              <small v-if="!countLoading">({{ count[4] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('discord') }}
              <small v-if="!countLoading">({{ count[5] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('googleChat') }}
              <small v-if="!countLoading">({{ count[6] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword"
                          :placeholder="$t('keyword')" v-on:keydown.enter="load"></b-form-input>
            <client-select :model="filterFormModel" attribute="client" @change="load" :isFilter="true"
                           :place-holder="$t('selectClient')" class="mr-1 mb-1"></client-select>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="status" :options="statusOptions" @change="load"></form-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-1"></div>
            <div class="col-lg-5">{{ $t('info') }}</div>
            <div class="col-lg-4">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-1">
              <figure class="c-board-table__avatar">
                <img src="/img/default-avatar.png" :alt="item.name" class="thumbnail">
              </figure>
            </div>
            <div class="col-lg-5">
              <div v-if="item.client">
                <div>
                  <span>Domain: </span>
                  <b v-if="item.client.domain">{{ item.client.domain }}</b>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>
                <div>
                  <span>{{ $t('clientCompany') }}: </span>
                  <b v-if="item.client.companyName">{{ item.client.companyName }}</b>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>
              </div>
              <div>
                <span>{{ $t('name') }}: </span>
                <b v-if="item.name">{{ item.name }}</b>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <span class="badge badge-success">{{ $t(item.type) }}</span>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <span>{{ $t('createTime') }}: </span><b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div v-if="item.updateTime">
                <span>{{ $t('updateTime') }}: </span><b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div v-if="item.expireTime">
                <span>{{ $t('expireTime') }}: </span><b>{{ item.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div>
                <span v-if="item.active" class="badge badge-success">{{ $t('activated') }}</span>
                <span v-else class="badge badge-danger">{{ $t('deactivated') }}</span>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="c-buttons__col">
                <button @click="update(item._id, 'teams')" type="button" class="btn btn-sm btn-info mr-1" v-if="item.type === 'teams'">
                  <font-awesome-icon icon="edit"/>
                  {{ $t('edit') }}
                </button>
                <button @click="update(item._id, 'larksuite')" type="button" class="btn btn-sm btn-info mr-1" v-if="item.type === 'larksuite'">
                  <font-awesome-icon icon="edit"/>
                  {{ $t('edit') }}
                </button>
                <button @click="update(item._id, 'slack')" type="button" class="btn btn-sm btn-info mr-1" v-if="item.type === 'slack'">
                  <font-awesome-icon icon="edit"/>
                  {{ $t('edit') }}
                </button>
                <button @click="update(item._id, 'telegram')" type="button" class="btn btn-sm btn-info mr-1" v-if="item.type === 'telegram'">
                  <font-awesome-icon icon="edit"/>
                  {{ $t('edit') }}
                </button>
                <button @click="update(item._id, 'discord')" type="button" class="btn btn-sm btn-info mr-1" v-if="item.type === 'discord'">
                  <font-awesome-icon icon="edit"/>
                  {{ $t('edit') }}
                </button>
                <button @click="update(item._id, 'googleChat')" type="button" class="btn btn-sm btn-info mr-1" v-if="item.type === 'googleChat'">
                  <font-awesome-icon icon="edit"/>
                  {{ $t('edit') }}
                </button>
                <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                  <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span>{{ $t('noClientBot') }}</span>
      </div>
      <b-modal v-model="showFormTeams" :title="formTitle" no-close-on-backdrop>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                    :label="$t('name')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="service"
                    :label="$t('service')"></form-input>
        <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                       :chk-label="$t('activated')"></form-checkbox>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="ml-1" @click="showFormTeams = false">
            {{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal v-model="showFormLarksuite" :title="formTitle" no-close-on-backdrop>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                    :label="$t('name')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="appId"
                    :label="$t('appId')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="appSecret"
                    :label="$t('appSecret')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="receiveType"
                    :label="$t('receiveType')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="group"  v-if="formModel.receiveType === 'chat_id'"
                    :label="$t('chat_id')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="group"  v-else
                    :label="$t('userEmail')"></form-input>
        <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                       :chk-label="$t('activated')"></form-checkbox>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="ml-1" @click="showFormLarksuite = false">
            {{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal v-model="showFormSlack" :title="formTitle" no-close-on-backdrop>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                    :label="$t('name')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="service"
                    :label="$t('service')"></form-input>
        <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                       :chk-label="$t('activated')"></form-checkbox>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="ml-1" @click="showFormSlack = false">
            {{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal v-model="showFormTelegram" :title="formTitle" no-close-on-backdrop>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                    :label="$t('name')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="service"
                    :label="$t('botToken')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="group"
                    :label="$t('chat_id')"></form-input>
        <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                       :chk-label="$t('activated')"></form-checkbox>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="ml-1" @click="showFormTelegram = false">
            {{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal v-model="showFormDiscord" :title="formTitle" no-close-on-backdrop>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                    :label="$t('name')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="service"
                    :label="$t('service')"></form-input>
        <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                       :chk-label="$t('activated')"></form-checkbox>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="ml-1" @click="showFormDiscord = false">
            {{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal v-model="showFormGoogleChat" :title="formTitle" no-close-on-backdrop>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                    :label="$t('name')"></form-input>
        <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="service"
                    :label="$t('service')"></form-input>
        <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                       :chk-label="$t('activated')"></form-checkbox>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="ml-1" @click="showFormGoogleChat = false">
            {{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";
import ClientSelect from "@/components/ClientSelect.vue";

export default {
  components: {ClientSelect},
  mixins: [List, CRUD],
  data() {
    return {
      service: '/client-bot',
      autoLoad: true,
      showFormTeams: false,
      showFormLarksuite: false,
      showFormSlack: false,
      showFormTelegram: false,
      showFormDiscord: false,
      showFormGoogleChat: false,
      defaultFilterFormModel: {
        type: null,
        client: this.client ? this.client._id : null,
        status: null,
      },
      statusOptions: [
        { value: null, text: this.$t('selectStatus') },
        { value: 'activated', text: this.$t('activated') },
        { value: 'deactivated', text: this.$t('deactivated') },
      ],
      tabIndex: 0,
      botTypes: [null, 'teams', 'larksuite', 'slack', 'telegram', 'discord', 'googleChat'],
      count: {},
      countLoading: true,
      afterLoad: function () {
        this.getCount();
      },
    }
  },
  watch: {
    tabIndex() {
      this.defaultFilterFormModel.type = this.botTypes[this.tabIndex];
      this.filterFormModel.type = this.botTypes[this.tabIndex];
      this.load();
    }
  },
  methods: {
    getCount() {
      this.countLoading = true;
      this.$service.get(this.service + '/count', {params: this.filterFormModel})
          .then(response => {
            this.count = response.data;
          }).catch(() => {
        this.count = {};
      }).finally(() => {
        this.countLoading = false;
      })
    },
    update: function (id, type) {
      let uri = this.service
      if (id) {
        uri += '/' + id
      }
      this.$service.get(uri, {
        params: this.filterFormModel
      }).then(response => {
        this.formModel = {}
        this.formTitle = this.$t('update')
        this.formErrors = {}
        if(type === 'teams') {
          this.showFormTeams = true;
        } else if(type === 'larksuite') {
          this.showFormLarksuite = true;
        } else if(type === 'slack') {
          this.showFormSlack = true;
        } else if(type === 'telegram') {
          this.showFormTelegram = true;
        } else if(type === 'discord') {
          this.showFormDiscord = true;
        } else if(type === 'googleChat') {
          this.showFormGoogleChat = true;
        }
        this.formModel = response.data;
        this.formModel.id = id
      })
    }
  },
  i18n: {
    messages: {
      en: {
        clientBot: "Client bot",
        clientDomain: 'Client domain',
        name: 'Client bot name',
        teams: 'Microsoft Teams',
        larksuite: 'Larksuite',
        slack: 'Slack',
        telegram: 'Telegram',
        noClientBot: 'No client bot',
        clientName: 'Client name',
        accountName: 'Account name',
        clientCompany: "Company name",
        service: "Service",
        appId: "App ID",
        appSecret: "App Secret",
        receiveType: "Loại",
        chat_id: "Chat ID",
        botToken: "Bot token",
        close: "Close",
        selectStatus: "Select status",
        activated: "Activated",
        deactivated: "Deactivated",
        discord: 'Discord',
        googleChat: 'Google Chat',
      },
      vi: {
        clientBot: "Tài khoản tích hợp",
        clientDomain: 'Domain khách hàng',
        name: 'Tên tài khoản tích hợp',
        teams: 'Microsoft Teams',
        larksuite: 'Larksuite',
        slack: 'Slack',
        telegram: 'Telegram',
        noClientBot: 'Không có tài khoản tích hợp',
        clientName: 'Tên khách hàng',
        accountName: 'Tên tài khoản mạng xã hội',
        clientCompany: 'Tên khách hàng',
        service: "URL nhận thông báo sự kiện",
        appId: "App ID",
        appSecret: "App secret",
        receiveType: "Loại",
        chat_id: "Cuộc trò chuyện (chat_id)",
        userEmail: "Email người dùng",
        close: "Đóng",
        selectStatus: "Chọn trạng thái",
        activated: "Được hoạt động",
        deactivated: "Dừng hoạt động",
        discord: 'Discord',
        googleChat: 'Google Chat',
      }
    }
  }
}
</script>

<style>
.c-board-table__avatar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #fff;
  border-radius: 50%;
}

.c-board-table__avatar img {
  width: auto;
  height: auto;
  min-height: 100%;
  min-width: 100%;
}
</style>